import './ProjectSection.css';
import ProjectBubbles from './ProjectBubbles';
export default function () {
    return (
      <section className="section projects-section">
          <h2>Projects & Experiences</h2>
          <br></br>
          <p></p>
          <ProjectBubbles />
      </section>
    );
  }
  